import { render } from "./WalletModal.vue?vue&type=template&id=7934c6b9&scoped=true"
import script from "./WalletModal.vue?vue&type=script&lang=js"
export * from "./WalletModal.vue?vue&type=script&lang=js"

import "./WalletModal.vue?vue&type=style&index=0&id=7934c6b9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7934c6b9"]])

export default __exports__